export const listPaymentMethods = `
   query listPaymentMethods($filter: PaymentMethodsFilterInput, $limit: Int, $nextToken: String) {
       listPaymentMethods(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              billingDetails {
                address
                email
                name
                phone
              }
              card {
                brand
                country
                expMonth
                expYear
                funding
                last4
              }
              created
              customerId
              livemode
              type
           }
           nextToken
       }
   }
`;

export const getPaymentMethod = `
   query getPaymentMethod($id:ID!) {
       getPaymentMethod(id:$id) {
              id
              billingDetails {
                address
                email
                name
                phone
              }
              card {
                brand
                country
                expMonth
                expYear
                fingerprint
                funding
                last4
              }
              created
              customerId
              livemode
              type
       }
}`;
